export const POOL = "pool";
export const ELIMINATION = "elimination";

export const getPhaseTypes = [POOL, ELIMINATION];
